import { render, staticRenderFns } from "./ManagePanel.vue?vue&type=template&id=5d8d47e3"
import script from "./ManagePanel.vue?vue&type=script&lang=js"
export * from "./ManagePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports